import Category from "../Components/Category"
import Hero from "../Components/Hero"
import PhoneHero from "../Components/PhoneHero"
import useFetch from "../Hooks/useFetch"

const Home = ()=>{
    const key = process.env.REACT_APP_API_KEY;
    const {results:topRated} = useFetch(`https://api.themoviedb.org/3/movie/top_rated?api_key=${key}&language=en-US&page=1`);
    const {results:popularTv} = useFetch(`https://api.themoviedb.org/3/tv/popular?api_key=${key}&language=en-US&page=1`);
    const {results:airingTv} = useFetch(`https://api.themoviedb.org/3/tv/on_the_air?api_key=${key}&language=en-US&page=1`);
    const {results:trending} = useFetch(`https://api.themoviedb.org/3/trending/all/day?api_key=${key}`);
    return <div className="dark:bg-secondary-dark min-h-screen  pb-2 ">
        <Hero/>
        <PhoneHero/>
        <Category name={'Top Rated'} data={topRated} cardType='movie'/>
        <Category name={'Popular Tv Shows' } data={popularTv} cardType='movie'/>
        <Category name = {'Airing Tv Shows'} data={airingTv} cardType='movie'/>
        <Category name={'Trending'} data={trending} cardType='movie'/>
        
    </div>
}

export default Home